import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PageContainer } from "@/components/layout/PageContainer";

export default function Copyright() {
  return (
    <PageContainer size="read">
        <Link href="/">
          <Button variant="ghost" className="mb-6" data-testid="button-back">
            <ArrowLeft className="h-4 w-4 mr-2" />
            목록으로
          </Button>
        </Link>

        <Card>
          <CardHeader>
            <CardTitle className="text-2xl font-bold">저작권 보호정책</CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <p className="text-muted-foreground">
              OZK News에 게재된 모든 기사, 이미지, 동영상 및 기타 콘텐츠는 저작권법의 보호를 받으며, 무단 복제·배포를 금합니다.
            </p>

            <div>
              <h3 className="text-lg font-semibold mb-3">1. 사이트 내 콘텐츠의 저작권</h3>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>자체 제작 콘텐츠는 OZK News에 귀속됩니다.</li>
                <li>일부 콘텐츠는 공공기관/언론사의 공개 자료를 기반으로 작성됩니다.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">2. 사용 허가 범위</h3>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>개인적, 비영리적 목적으로는 인용 가능 (출처 명시 필수)</li>
                <li>상업적 활용, 재편집, 변형, 재배포는 허용되지 않습니다.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">3. 이미지 사용 정책</h3>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>Unsplash, Pexels 등 무료 이미지 라이선스를 준수합니다.</li>
                <li>이미지 출처는 각 이미지 하단에 표시됩니다.</li>
                <li>사용자가 업로드한 이미지는 해당 사용자의 저작권을 존중합니다.</li>
                <li>저작권 침해가 의심되는 이미지는 즉시 삭제 조치를 취합니다.</li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-3">4. 저작권 침해 신고</h3>
              <p className="text-muted-foreground mb-2">
                본 사이트에 게시된 콘텐츠 중 문제가 있다고 판단될 경우 아래로 신고해주세요.
              </p>
              <p>
                📧 이메일:{" "}
                <a href="mailto:ozknews.com@gmail.com" className="text-primary hover:underline">
                  ozknews.com@gmail.com
                </a>
              </p>
            </div>
          </CardContent>
        </Card>
    </PageContainer>
  );
}
